<template>
  <div class="wage-slip-report-main">
    <left-tree class="left-box" @project-change="projectChange" > </left-tree>

    <div class="right-box">
      <div class="top-tit">
        <div class="form-cen-tit" v-if="currLabel">{{ currLabel }}</div>
      </div>
      <!-- 工资月份 -->
      <div class="top-date">
        <el-form inline label-width="120px" class="top-form">
          <el-form-item class="top-item">
            <el-select v-model="dataShowType" @change="dataShowTypeChange">
              <el-option :value="true" label="明细"></el-option>
              <el-option :value="false" label="统计"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工资月份:">
            <el-date-picker v-model="salaryMonthRange" type="monthrange" align="right" unlink-panels range-separator="至"
              start-placeholder="开始月份" end-placeholder="结束月份" value-format="YYYY-MM"
              @change="salaryMonthRangeChange" style="margin-right: 15px;width: 250px;">
            </el-date-picker>
          </el-form-item>
          <el-form-item >
            <el-input v-model="params.name" placeholder="输入姓名搜索" clearable></el-input>
          </el-form-item>
          <el-form-item >
            <el-button type="primary" @click="dataShowTypeChange"><el-icon><search /></el-icon>搜索</el-button>
          </el-form-item>
          <el-form-item >
             <el-button type="primary" @click="loadWageSlipTotalData" plain :disabled="!getPower('99642756791534528')"><el-icon><download /></el-icon>导出</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 工资统计 -->
      <div class="top-total">
         <div class="tot-cen" style="background: linear-gradient(135deg, #ECF7FF 0%, #D3EAFF 100%);">
            <div class="c-lt">
              <img :src="yfgz" alt=""  style="cursor:pointer;"/>
              <div class="c-lt-t">应发工资</div>
            </div>
            <div class="c-rt">
              ¥ {{totalSlipStatistics.shouldPaySalary || 0}}
            </div>
         </div>
         <div class="tot-cen" style="background: linear-gradient(135deg, #FFFBF7 0%, #FFE7D4 100%);">
            <div class="c-lt">
              <img :src="ykjgz" alt=""  style="cursor:pointer;"/>
              <div class="c-lt-t">应扣缴工资</div>
            </div>
            <div class="c-rt">
              ¥ {{totalSlipStatistics.shouldDeduction || 0}}
            </div>
         </div>
         <div class="tot-cen" style="background: linear-gradient(135deg, #F8FFF7 0%, #DCFFD5 100%);">
            <div class="c-lt">
              <img :src="sfgz" alt=""  style="cursor:pointer;"/>
              <div class="c-lt-t">实发工资</div>
            </div>
            <div class="c-rt">
              ¥ {{totalSlipStatistics.actualSalary || 0}}
            </div>
         </div>
      </div>
      <!-- 上传内容 -->
      <div class="data-center">
          <el-table :data="tableData"  tooltip-effect="dark" border stripe height="100%" v-loading="loading">
          <el-table-column type="index" label="序号" width="55" fixed="left"/>
          <el-table-column label="姓名" width="120" fixed="left">
              <template #default="scope">{{ scope.row.name }}</template>
          </el-table-column>
          <el-table-column label="群组" >
              <template #default="scope">
                {{ scope.row.projectName }}{{scope.row.teamName?'/'+scope.row.teamName:''}}{{scope.row.groupName?'/'+scope.row.groupName:''}}
              </template>
          </el-table-column>
          <el-table-column label="工资月份" width="120" v-if="dataShowType">
              <template #default="scope">{{ scope.row.salaryMonth }}</template>
          </el-table-column>
          <el-table-column label="工种" width="120">
              <template #default="scope">{{ scope.row.typeOfWorkName }}</template>
          </el-table-column>
          <el-table-column label="工资参考上限" width="120">
              <template #default="scope">{{ scope.row.salaryUpperLimit }}</template>
          </el-table-column>
          <el-table-column :label="dataShowType?'当月应发':'累计应发'" width="120">
              <template #default="scope">{{ scope.row.shouldPaySalary }}</template>
          </el-table-column>
          <el-table-column :label="dataShowType?'当月实发':'累计实发'" width="120">
              <template #default="scope">{{ scope.row.actualSalary }}</template>
          </el-table-column>
          <el-table-column :label="dataShowType?'当月扣除':'累计扣除'" width="120">
              <template #default="scope">{{ scope.row.shouldPaySalary-scope.row.actualSalary }}</template>
          </el-table-column>
          <el-table-column label="操作" width="100" fixed="right" v-if="dataShowType">
            <template #default="scope">
                <el-button type="text" @click="openDetail(scope.row)">明细</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pages-main">
          <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="total"
            :current-page="params.pageNo" :page-size="params.length" @current-change="pageNoChange"
            @size-change="lengthChange">
          </el-pagination>
      </div>

    </div>

    <detail :title="slipDetailDrawerTitle"  v-model="isShowSlipDetailDrawer" :detailData="detailData"> </detail>

  </div>
</template>
<script>
import LeftTree from './LeftTree.vue'
import Detail from './Detail.vue';
import {defineComponent, shallowRef} from 'vue'
import yfgz from '@/assets/icon/wage/icon-yfgz.png';
import ykjgz from '@/assets/icon/wage/icon-ykjgz.png';
import sfgz from '@/assets/icon/wage/icon-sfgz.png';
import wzf from '@/assets/icon/wage/icon-wzf.png';
import { ElMessage } from 'element-plus'
import { getWageAuditList,getWageTotalList,getSlipStatistics,loadWageSlipTotal} from "@/api/wage/audit";
import { exportFile } from '@/utils/fileUtil';
import { isHaveOrgPower } from '@/utils/common';
import { downFile} from '@/api/heimingdan/heimingdan';

export default defineComponent({
    components: { LeftTree,Detail},
    data() {
      return {
        yfgz,ykjgz,sfgz,wzf,//图标

        loading: false,
        //默认选中项目
        project: {},

        dataShowType:true,//数据显示类型 (明细：true，统计：false)

        total: 0,
        salaryMonthRange: '',
        params: {
          pageNo: 1,
          length: 20,
          salaryMonthStart: null,
          salaryMonthEnd: null,
          name: null,
          status:6,//只统计已发放状态
          apiGetType:'REPORT'//api接口调用类型==AUDIT:审核列表
        },
        //列表数据
        tableData:[],

        //统计数据
        totalSlipStatistics:{},

        //详情抽屉
        isShowSlipDetailDrawer:false,
        //详情标题
        slipDetailDrawerTitle:'',
        //详情数据
        detailData:{},
      }
    },
    mounted() {
      
    },
    computed: {
      currLabel() {
        let project = this.project;
        if(!project){
          return "";
        }
        // let label = project.projectShortName || project.projectName;
        let label = project.projectName;
        if (project.teamName) {
          label += ' > ' + project.teamName;
        }
        if (project.groupName) {
          label += ' > ' + project.groupName;
        }
        return label
      },
    
    },
    methods: {
      projectChange(project) { // 项目层级改变事件
        this.project = project;
        //获取数据
        this.querySlipStatistics();
        this.searchData();
      },
      //查询工资条统计信息
      querySlipStatistics(){
        let param ={};
        if("PROJECT"===this.project.type){
          param={projectId:this.project.id};
        }else if("TEAM"===this.project.type){
          param={teamId:this.project.id};
        }else if("GROUP"===this.project.type){
          param={groupId:this.project.id};
        }
        param['salaryMonthStart']=this.params.salaryMonthStart;
        param['salaryMonthEnd']=this.params.salaryMonthEnd;
        param['name']=this.params.name;
        param['status']=this.params.status;
        getSlipStatistics(param).then(res => {
            this.totalSlipStatistics=res.data.data;
        }).catch(err => {
            console.log(err);
        });
      },
       searchData() {
        this.params.pageNo = 1;
        this.getData();
        this.querySlipStatistics();
      },
      pageNoChange(pageNo) {
        this.params.pageNo = pageNo;
        this.getData();
      },
      lengthChange(length) {
        this.params.length = length;
        this.searchData();
      },
      //切换数据列表
      dataShowTypeChange(){
        if(this.dataShowType){
          this.searchData()
        }else{
          this.getTotalData();
        }
      },
      //默认获取数据==明细
      getData() {
        this.loading = true;
        let param =this.params;
        if("PROJECT"===this.project.type){
          param['projectId']=this.project.id
          param['teamId']=''
          param['groupId']=''
        }else if("TEAM"===this.project.type){
          param['projectId']=''
          param['teamId']=this.project.id
          param['groupId']=''
        }else if("GROUP"===this.project.type){
          param['projectId']=''
          param['teamId']=''
          param['groupId']=this.project.id
        }
        getWageAuditList(param).then(({data}) => {console.log(data);
          this.tableData = data.data;
          for(let v of this.tableData){
            v=this.downWageFile(v);
          }
          this.total = data.page.totalRecords;
          this.loading = false;
        }).catch(_ => this.loading = false);
      },
      //获取数据==统计
      getTotalData() {
        this.loading = true;
        let param =this.params;
        if("PROJECT"===this.project.type){
          param['projectId']=this.project.id
          param['teamId']=''
          param['groupId']=''
        }else if("TEAM"===this.project.type){
          param['projectId']=''
          param['teamId']=this.project.id
          param['groupId']=''
        }else if("GROUP"===this.project.type){
          param['projectId']=''
          param['teamId']=''
          param['groupId']=this.project.id
        }
        getWageTotalList(param).then(({data}) => {
          this.tableData = data.data;
          this.total = data.page.totalRecords;
          this.loading = false;
        }).catch(_ => this.loading = false);
      },
      //时间段修改
      salaryMonthRangeChange(val) {
        if (val) {
          this.params.salaryMonthStart = val[0];
          this.params.salaryMonthEnd = val[1];
        } else {
          this.params.salaryMonthStart = null;
          this.params.salaryMonthEnd = null;
        }
        this.searchData();
      },
      //打开详情
      openDetail(row){
          this.detailData=row;
          this.slipDetailDrawerTitle=row.name+"工资详情";
          this.isShowSlipDetailDrawer=true;
      },
      //导出列表
      loadWageSlipTotalData(){
        let param =this.params;
        if("PROJECT"===this.project.type){
          param['projectId']=this.project.id
        }else if("TEAM"===this.project.type){
          param['teamId']=this.project.id
        }else if("GROUP"===this.project.type){
          param['groupId']=this.project.id
        }
        param['isTotalData']=this.dataShowType;
        loadWageSlipTotal(param).then(res=>{
           exportFile(res) 
        })
      },
      //获取权限
      getPower(powerId){
        return isHaveOrgPower(powerId);
      },
      downWageFile(row) {
            row.fileList=[];
            if(row.attrPath){
                let fA=row.attrPath.split(',');
                if(fA.length>0){
                    for(let path of fA){
                        if(path){
                            let param={attrPaths:path},name=path.substring(path.lastIndexOf("\\")+1);
                            downFile(param).then((rep)=>{console.log('downFile',rep);
                                row.fileList.push({name,url:URL.createObjectURL(rep.data),fi:{name,size:rep.data.size,path},fObj:rep.data});
                            });
                        }
                    }
                }
            }
        },
    }
})
</script>

<style lang="scss" scoped>
.wage-slip-report-main{
  width: 100%;
  height: 100%;
  display: flex;
  .left-box{
     width: 20%;
     height: calc(100% - 40px);
     border-right: 1px solid #ccc;
     padding: 20px 10px;
  }
  .right-box {
    width: calc(80% - 61px);
    padding: 20px;
    .top-tit{
      display: flex;
      .form-cen-tit{
        padding: 5px 25px 5px 5px;
        background: linear-gradient(-45deg,transparent 20px, #0099ff 0) bottom right,
                    linear-gradient(-135deg,transparent 20px,#00548c 0) top right;
        color: white;
        font-size: 14px;
        font-weight: bold;
        min-width: 200px;
      }
    }
    .top-date{
      display: flex;
      padding: 20px 20px 0px 0px;
      justify-content: center;
      .top-form{
        .top-item{
          .el-select,
          .el-input {
            margin-right: 15px;
          }
          .el-select {
            width: 120px;
          }
          .el-input {
            width: 200px;
          }
        }
      }
    }
    .top-total{
      display: flex;
      padding: 0px 20px 10px 20px;
      justify-content: space-between;
      padding-left: 10%;
      padding-right: 10%;
      .tot-cen{
        width: 250px;
        height: 130px;
        padding: 10px;
        display: flex;
        justify-content: space-evenly;
        font-size: 16px;
        flex-flow: column;//上下布局
        .c-lt{
          display: flex;
          align-items: center;
          padding: 0px 17px;
          .c-lt-t{
            color: #666666;
            padding: 0px 16px;
            font-size: 14px;
          }
        }
        .c-rt{
          display: flex;
          justify-content: right;
          padding: 0px 32px;
          font-size: 26px;
          color: #333333;
        }
      }
    }
    .data-center{
      display: flex;
      justify-content: center;
      height: calc(100% - 375px);
      padding: 20px;
    }
    .pages-main{
      width: 100%;
    }
    
  }
}

</style>